import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  SettlementListQuery,
  SettlementRepository,
} from '@app/domain/ports/tpv/settlement.repository';
import { TpvSettlement, TpvSettlementCreated } from '@app/domain/models/tpv/settlement.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { CreateSettlementRequest } from '@app/data/dtos/tpv/settlement.dto';

/** Mock de liquidaciones para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class SettlementMockDataSource extends SettlementRepository {
  private readonly settlements: TpvSettlement[] = [
    {
      merchantName: 'Comercio Demo 1',
      date: '2026-06-01',
      orderingTitular: 'Ordenante Demo 1',
      orderingClabe: '012345678901234561',
      beneficiaryTitular: 'Beneficiario Demo 1',
      beneficiaryClabe: '012345678901234562',
      bank: 'BBVA',
      amount: 1500.5,
      concept: 'Liquidación demo 1',
      reference: 'REF000001',
      trackingKey: 'CR0000000000000000001',
      operationType: 'SPEI',
      captured: '2026-06-01T10:00:00Z',
    },
    {
      merchantName: 'Comercio Demo 2',
      date: '2026-06-02',
      orderingTitular: 'Ordenante Demo 2',
      orderingClabe: '012345678901234563',
      beneficiaryTitular: 'Beneficiario Demo 2',
      beneficiaryClabe: '012345678901234564',
      bank: 'Santander',
      amount: 3200,
      concept: 'Liquidación demo 2',
      reference: 'REF000002',
      trackingKey: 'CR0000000000000000002',
      operationType: 'SPEI',
      captured: '2026-06-02T11:30:00Z',
    },
    {
      merchantName: 'Comercio Demo 3',
      date: '2026-06-03',
      orderingTitular: 'Ordenante Demo 3',
      orderingClabe: '012345678901234565',
      beneficiaryTitular: 'Beneficiario Demo 3',
      beneficiaryClabe: '012345678901234566',
      bank: 'Banorte',
      amount: 875.25,
      concept: 'Liquidación demo 3',
      reference: 'REF000003',
      trackingKey: 'CR0000000000000000003',
      operationType: 'SPEI',
      captured: '2026-06-03T09:15:00Z',
    },
  ];

  override getSettlements(
    _externalIdMerchant: string,
    query: SettlementListQuery = {},
  ): Observable<TpvPage<TpvSettlement>> {
    return of({
      data: this.settlements,
      total: this.settlements.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }

  override getSettlementById(
    _idSettlement: string | number,
  ): Observable<TpvSettlement | null> {
    return of<TpvSettlement>(this.settlements[0]).pipe(delay(300));
  }

  override createSettlement(
    _request: CreateSettlementRequest,
    _idempotencyKey?: string,
  ): Observable<TpvSettlementCreated> {
    const uuid =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `mock-settlement-${Date.now().toString(36)}`;
    return of<TpvSettlementCreated>({ idSettlement: uuid }).pipe(delay(400));
  }
}
